export const AddressDataFragment = `
	id
    address1
    address2
    city
    state
    postal_code
    country
`
